import { initializeApp, getApps } from 'firebase/app';
import {
	getAnalytics,
	logEvent,
	setUserId,
	setUserProperties,
	type Analytics,
} from 'firebase/analytics';

let analytics: Analytics | null = null;

const firebaseConfig = {
	apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
	authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
	projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
	storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
	appId: process.env.REACT_APP_FIREBASE_APP_ID,
	measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const isConfigured = firebaseConfig.apiKey && firebaseConfig.projectId;

export function initFirebase(): Analytics | null {
	if (!isConfigured) return null;
	try {
		const app =
			getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
		analytics = getAnalytics(app);
		return analytics;
	} catch (e) {
		console.warn('[Firebase] Init failed:', (e as Error).message);
		return null;
	}
}

export function fbLogEvent(
	eventName: string,
	params: Record<string, unknown> = {},
): void {
	if (!analytics) return;
	try {
		logEvent(analytics, eventName, params);
	} catch {
		/* silent */
	}
}

export function fbSetUser(
	userId: string,
	props: Record<string, string> = {},
): void {
	if (!analytics) return;
	try {
		setUserId(analytics, userId);
		setUserProperties(analytics, props);
	} catch {
		/* silent */
	}
}
